import { useMemo, useState } from "react";
import { CustomActionDelete } from "../components/CustomActionDelete";
import { CustomActionToggle } from "../components/CustomActionToggle";
import { StopCallRecordingTriggerEdit } from "./StopCallRecordingTriggerEdit";
import { StopCallRecordingTriggerCreate } from "./StopCallRecordingTriggerCreate";
import { useCustomActions } from "../useCustomActions";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";
import StopCallRecordingTriggersTable from "./StopCallRecordingTable";
import { Heading } from "V2.0/common/heading";

function StopCallRecordingTriggers(props) {
  const { customActions, syncAssistant, workspaceId, assistantId, locked } = props;
  const { customActionsArray, recordingAutoStopEnabled } = customActions;
  const {
    removeCustomAction,
    toggleCustomAction,
    createCustomAction,
    updateCustomAction,
  } = useCustomActions({
    syncAssistant,
    workspaceId,
    assistantId,
  });
  const [openEdit, setOpenEdit] = useState({
    isOpen: false,
    item: null,
    index: null,
  });
  const [openDelete, setOpenDelete] = useState({
    isOpen: false,
    item: null,
    index: null,
  });

  const stopCallRecordingTriggers = useMemo(() => {
    if (customActionsArray.length > 0) {
      return customActionsArray.filter(
        (action) => action.actionFunction === "STOPRECORDING"
      );
    }

    return [];
  }, [customActionsArray]);

  const handleItemDelete = (lifecycleCbs) => {
    removeCustomAction(openDelete.item._id, lifecycleCbs);
  };

  const handleToggleCustomAction = (state) => {
    const payload = {
      recordingAutoStopEnabled: state,
    };

    const loadingMessage = state
      ? "Enabling Stop Call Recording Triggers.."
      : "Disabling Stop Call Recording Triggers..";
    const successMessage = state
      ? "Stop Call Recording Triggers enabled"
      : "Stop Call Recording Triggers disabled";

    const lifecycleCbs = {
      init: () => {
        message.loading(loadingMessage);
      },
      success: () => {
        message.destroy();
        message.success(successMessage);
      },
      error: (e) => {
        message.destroy();
        showErrorToast(e, "Failed to update Stop Call Recording Triggers");
      },
    };

    toggleCustomAction(payload, lifecycleCbs);
  };

  const handleItemEdit = (data, lifecycleCbs) => {
    updateCustomAction(data, openEdit.item._id, lifecycleCbs);
  };

  return (
    <>
      <div className="w-3/4 min-w-[600px] m-4 flex flex-col gap-y-2 border rounded-lg">
        <div className="flex justify-between px-6 py-4 bg-gray-50 rounded-t-lg">
          <div className="flex items-center gap-x-2">
            <p className="text-md font-semibold text-gray-900">
              Stop Call Recording Triggers
            </p>
            {!locked && (
              <CustomActionToggle
                isEnabled={recordingAutoStopEnabled}
                onToggleCustomAction={handleToggleCustomAction}
              />
            )}
          </div>
          {!locked && (
            <StopCallRecordingTriggerCreate
              onTriggerCreate={createCustomAction}
            />
          )}
        </div>
        <div className="min-h-96 px-6">
          <StopCallRecordingTriggersTable
            stopCallRecordingTriggers={stopCallRecordingTriggers}
            onEdit={setOpenEdit}
            onDelete={setOpenDelete}
            showActions={!locked}
          />
        </div>
      </div>
      {openDelete.isOpen && (
        <CustomActionDelete
          open={true}
          onClose={() =>
            setOpenDelete({ isOpen: false, item: null, index: null })
          }
          onDelete={handleItemDelete}
        />
      )}
      {openEdit.isOpen && (
        <StopCallRecordingTriggerEdit
          open={true}
          onClose={() =>
            setOpenEdit({ isOpen: false, item: null, index: null })
          }
          onTriggerEdit={handleItemEdit}
          stopCallRecordingTrigger={openEdit.item}
        />
      )}
    </>
  );
}

export { StopCallRecordingTriggers };
